import { render, staticRenderFns } from "./ConfigScriptAdd.vue?vue&type=template&id=28887cf0&"
import script from "./ConfigScriptAdd.vue?vue&type=script&lang=js&"
export * from "./ConfigScriptAdd.vue?vue&type=script&lang=js&"
import style0 from "./ConfigScriptAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports